module.exports = "/shared/img/fast-betting-btn-purple.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/fast-betting-btn-purple.png
// module id = 4
// module chunks = 13